import { Grid, RadioGroup, Typography, Alert } from '@mui/material';
import RadioButton from 'shared/ui/RadioButton/RadioButton';
import { StyledButton } from 'shared/ui/Button/styles';
import ModalWindow from 'shared/ui/ModalWindow/ModalWindow';
import React from 'react';
interface Props {
	questionModal: boolean;
	onClose: () => void;
	questionAnswer: string;
	handleChange:  (event: React.ChangeEvent<HTMLInputElement>) => void
	onSubmit:  () => void
	isPending:  boolean
	isErrorTenantFetch:  boolean
	errorMessage: string
}
const ModalRIQuestion = (props: Props) => {
	const {onClose, questionModal, handleChange, questionAnswer, onSubmit, isPending, isErrorTenantFetch, errorMessage} = props
	return (
		<ModalWindow open={questionModal} handleClose={onClose} header={
			<Typography variant="h4" mb={0}>Just covering the bases</Typography>
		}
		>
			<Grid size={12}>
				<Typography variant="subtitle2" fontWeight="normal" >
					During the last 10 years, has any applicant been formally charged or convicted of any degree of crime or fraud,
					bribery or arson in connection with this or any other property?
				</Typography>
			</Grid>
			<Grid size={12}>
				<RadioGroup
					value={questionAnswer}
					onChange={handleChange}
					aria-label="icon-radio"
				>
					<Grid container spacing={2}>
						<Grid size={{md: 6, sm: 6, xs:12 }}>
							<RadioButton
								checked={questionAnswer === 'Y'}
								value={'Y'}
								label="YES"
								label2={""}
							/>
						</Grid>
						<Grid size={{md: 6, sm: 6, xs:12 }}>
							<RadioButton
								checked={questionAnswer === 'N'}
								value={'N'}
								label="NO"
								label2={""}
							/>
						</Grid>
					</Grid>
				</RadioGroup>
			</Grid>
			{isErrorTenantFetch && <Grid size={12} justifyContent="center">
				<Alert severity="error">{errorMessage}</Alert>
			</Grid>}
			<Grid size={{md: 4, sm: 6, xs:8 }}>
				<StyledButton variant="outlined" onClick={onSubmit} loading={isPending}>
					CONTINUE
				</StyledButton>
			</Grid>
		</ModalWindow>
	)
}

export default ModalRIQuestion
